// Imports
import Vue from 'vue'
import Router from 'vue-router'
// import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

const router = new Router({
/*
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
*/
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },

        {
          path: 'docs1',
          name: 'About2',
          component: () => import('@/views/about/Index2.vue'),
          meta: { src: require('@/assets/images/NTruroBeach.jpg') },
        },
        {
          path: 'docs',
          name: 'docs',
          component: () => import('@/views/about/docs.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },

        {
          path: 'about2',
          name: 'About2',
          component: () => import('@/views/about/Index2.vue'),
          meta: { src: require('@/assets/images/NTruroBeach.jpg') },
        },

        {
          path: 'about',
          name: 'About',
          component: () => import('@/views/about/Index.vue'),
          meta: { src: require('@/assets/images/NTruroBeach.jpg') },
        },

        {
          path: 'news',
          name: 'News',
          component: () => import('@/views/news/Index.vue'),
          meta: { src: require('@/assets/images/CornHillBeach1.jpg') },
        },

        {
          path: 'news/:slug',
          name: 'Article',
          component: () => import('@/views/news/Article.vue'),
          meta: { src: require('@/assets/article.jpg') },
        },

        {
          path: 'marketing',
          name: 'Marketing',
          component: () => import('@/views/marketing/Index.vue'),
          meta: { src: require('@/assets/marketing.jpg') },
        },

        {
          path: 'gallery',
          name: 'Gallery',
          component: () => import('@/views/gallery/Index.vue'),
          meta: { src: require('@/assets/gallery.jpg') },
        },
        /*
        {
          path: 'projects/:project',
          name: 'Project',
          component: () => import('@/views/gallery/Project.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        */
        {
          path: 'projects/water',
          name: 'splashWQ',
          component: () => import('@/views/projects/water/splashWQ.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/wells',
          name: 'wells',
          component: () => import('@/views/projects/water/Wells.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/waterQuality',
          name: 'splashWQ',
          component: () => import('@/views/projects/water/splashWQ.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'wp',
          name: 'splashWQ',
          component: () => import('@/views/projects/water/splashWQ.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'waterprotectors',
          name: 'splashWQ',
          component: () => import('@/views/projects/water/splashWQ.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'water',
          name: 'splashWQ',
          component: () => import('@/views/projects/water/splashWQ.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/adapt',
          name: 'Adapt',
          component: () => import('@/views/projects/water/Adapt.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/mitigate',
          name: 'Mitigate',
          component: () => import('@/views/projects/water/Mitigate.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/neighborhood',
          name: 'Neighborhood',
          component: () => import('@/views/projects/water/Neighborhood.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/health',
          name: 'Health',
          component: () => import('@/views/projects/water/Health.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'nz',
          name: 'netZero',
          component: () => import('@/views/projects/netZero/NetZero.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
        path: 'netzero',
        name: 'netZero',
        component: () => import('@/views/projects/netZero/NetZero.vue'),
        meta: { src: require('@/assets/project.jpg') },
        },

        {
          path: 'cp',
          name: 'climateActivists',
          // name: 'climateProtectors',
          component: () => import('@/views/projects/climate/Index.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/climateprotectors',
          name: 'climateActivists',
          // name: 'climateProtectors',
          component: () => import('@/views/projects/climate/Index.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'ca',
          name: 'climateActivists',
          component: () => import('@/views/projects/climate/Index.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/climateactivists',
          name: 'climateActivists',
          component: () => import('@/views/projects/climate/Index.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'pv',
          name: 'pondVillage',
          component: () => import('@/views/projects/water/PondVillage.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'waterpv',
          name: 'pondVillage',
          component: () => import('@/views/projects/water/PondVillage.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/pv',
          name: 'pondVillage',
          component: () => import('@/views/projects/water/PondVillage.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'pv/water',
          name: 'pondVillageWater',
          component: () => import('@/views/projects/water/PondVillageWater.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'pv/z',
          name: 'pondVillageZ',
          component: () => import('@/views/projects/water/PondVillageZ.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },

        {
          path: 'pv/equity',
          name: 'pondVillageEquity',
          component: () => import('@/views/projects/water/PondVillageEquity.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'projects/water/equity',
          name: 'pondVillageEquity',
          component: () => import('@/views/projects/water/PondVillageEquity.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'water/ntruro',
          name: 'Ntruro',
          component: () => import('@/views/projects/water/Ntruro.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },

        {
          path: 'projects/water/waterRo',
          name: 'WaterRo',
          component: () => import('@/views/projects/water/WaterRo.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },

        {
          path: 'learn',
          name: 'Learn',
          // component: () => import('@/views/sections/Learn.vue'),
          component: () => import('@/views/learn/Index.vue'),
          meta: { src: require('@/assets/images/onlineStudy.jpg') },
        },
        {
        path: 'act',
        name: 'Act',
        // component: () => import('@/views/sections/Act.vue'),
        component: () => import('@/views/act/Index.vue'),
        meta: { src: require('@/assets/images/startingBlock.jpg') },
        },
        {
          path: 'projects',
          name: 'Projects',
          // component: () => import('@/views/sections/Projects.vue'),
          component: () => import('@/views/projects/Index.vue'),
          meta: { src: require('@/assets/project.jpg') },
        },
        {
          path: 'pricing-plans',
          name: 'Pricing',
          component: () => import('@/views/pricing-plans/Index.vue'),
          meta: { src: require('@/assets/pricing.jpg') },
        },
        {
          path: 'contact-us',
          name: 'Contact',
          component: () => import('@/views/contact-us/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'pro',
          name: 'Pro',
          component: () => import('@/views/pro/Index.vue'),
          meta: { src: require('@/assets/pro.jpg') },
        },
        {
          path: 'kitchen-sink',
          name: 'Sink',
          component: () => import('@/views/sink/Index.vue'),
          meta: { src: require('@/assets/sink.jpg') },
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    },
    {
      path: 'about2',
      name: 'about2',
      component: () => import('@/views/about/Index2.vue'),
    },

    // tried adding this but didn't help
    /*
    {
      path: 'about2',
      name: 'About2',
      component: () => import('@/views/about/Index2.vue'),
    },
    {
      path: 'about',
      name: 'About',
      component: () => import('@/views/about/Index.vue'),
    },
    */
  ],
})

export default router
